import { t } from '@lingui/macro'

import type { AllergyProfileStatus } from '@/modules/app/types/HealthParameter.types'

/**
 * Returns the localized empty-state message for the allergy confirmed-empty
 * scheme status ("patient confirmed they have no known allergies").
 *
 * Returns undefined for any other status — callers keep their own handling
 * of the unconfirmed/unknown empty state, which differs per surface.
 */
export function getAllergyEmptyMessage(schemeStatus?: AllergyProfileStatus): string | undefined {
  if (schemeStatus === 'confirmed-empty') {
    return t({
      id: 'observation.allergy.confirmed-empty',
      message: 'Geen gekende allergieën',
    })
  }

  return undefined
}
